<script>
  import { cart, deliveryServices, paymentServices, lockerPoint } from './storage.js';
  import Loader from '../components/Loader.svelte';
  import InpostGeowidget from './InpostGeowidget.svelte';
  import Modal from './Modal.svelte';
  import { getDeliveryServices, getPaymentServices } from './requests.js';
  import { onMount } from 'svelte';
  import { updateCart, showErrors } from './requests.js';

  let { onrefresh, ondeliverychange, onclose, openSelector = false, openLockerModal = $bindable(false) } = $props();

  let selector = $state(openSelector);
  let loaded = $state(false);
  let showLockerModal = $state(false);
  let fetchError = $state(false);

  $effect(() => {
    if (openLockerModal) {
      showLockerModal = true;
      openLockerModal = false;
    }
  });

  const closeSelector = () => {
    selector = false;
    onclose?.();
  }

  const select = (methodId, paymentOnDelivery) => {
    const prevServiceId = $cart.delivery_service_id;
    const prevPaymentOnDelivery = $cart.payment_on_delivery;
    $cart.delivery_service_id = methodId;
    $cart.payment_on_delivery = paymentOnDelivery;

    const payload = {
      token: $cart.token,
      delivery_service_id: methodId,
      payment_on_delivery: paymentOnDelivery
    }
    updateCart($cart.id, payload).then(() => {
      onrefresh?.();
      ondeliverychange?.(selectedMethod);
    }).catch((err) => {
      $cart.delivery_service_id = prevServiceId;
      $cart.payment_on_delivery = prevPaymentOnDelivery;
      showErrors(err);
    });
    closeSelector();

    const method = ($deliveryServices || []).find(item => item.id === methodId);
    if (method?.type === 'DeliveryService::InpostLocker' && !$lockerPoint) {
      showLockerModal = true;
    }
  }

  const fetchDeliveryServices = async () => {
    if ($deliveryServices == null) {
      try {
        $deliveryServices = (await getDeliveryServices()).items;
        fetchError = false;
      } catch {
        fetchError = true;
      }
    }

    return $deliveryServices || [];
  }

  let fetchPromise = $state(fetchDeliveryServices());

  const retryFetch = () => {
    $deliveryServices = null;
    fetchError = false;
    fetchPromise = fetchDeliveryServices();
  }

  const fetchPaymentServices = async () => {
    if (!$paymentServices) {
      try {
        $paymentServices = (await getPaymentServices()).items;
      } catch {
        // silent — payment services are informational only in the cart
      }
    }

    return $paymentServices;
  }

  onMount(async () => {
    fetchPaymentServices();

    if ($cart && $cart.delivery_service_id) {
      await fetchDeliveryServices();
      // TODO: fallback when delivery service will be deactivated in the meantime
    }

    loaded = true;
  });

  const anyUpfront = (data) => {
    return data.some(item => item['price_upfront'] != null);
  }
  const anyOnDelivery = (data) => {
    return data.some(item => item['price_on_delivery'] != null);
  }

  let selectedMethod = $derived(($deliveryServices ? $deliveryServices : []).find(item => item['id'] === $cart.delivery_service_id));

  const handleLockerSelect = ({ name, address }) => {
    $lockerPoint = { name, address };
    showLockerModal = false;
  };
</script>

{#if !openSelector}
  <div class="delivery">
    {#if $cart && loaded}
      <div class="delivery__info">
        <div class="delivery__label">
            Dostawa:
        </div>
        {#if $cart.delivery_service_id && selectedMethod}
          <div class="delivery__value">
            {selectedMethod.name}
          </div>
        {:else}
          <a class="delivery__choice" onclick={() => selector = true}>wybierz</a>
        {/if}
      </div>

      {#if $cart.delivery_service_id}
        <a class="delivery__change" onclick={() => selector = true}>zmień</a>
      {/if}

      {#if selectedMethod?.type === 'DeliveryService::InpostLocker'}
        <div class="delivery__locker">
          {#if $lockerPoint}
            <div class="delivery__locker-name">{$lockerPoint.name}</div>
            <div class="delivery__locker-address">{$lockerPoint.address}</div>
            <a class="delivery__change" onclick={() => showLockerModal = true}>wybierz inny</a>
          {:else}
            <a class="delivery__choice" onclick={() => showLockerModal = true}>wybierz paczkomat</a>
          {/if}
        </div>
      {/if}
    {:else if $cart}
      <Loader />
    {/if}
  </div>
{/if}

{#if selector && $cart}
  <Modal onclose={closeSelector}>
    <div class="delivery__selector">
      <h3 class="selector__title">Wybierz sposób dostawy</h3>

      {#await fetchPromise}
        <Loader />
      {:then response}
        {#if fetchError}
          <p class="fetch-error">Nie udało się załadować metod dostawy.</p>
          <button class="retry-button" onclick={retryFetch}>Spróbuj ponownie</button>
        {:else}
          {#if anyUpfront(response)}
            <div class="options__label">Płatność z góry:</div>
            <div class="options__list">
              {#each response.filter(item => item.price_upfront != null) as method}
                <label onclick={() => select(method.id, false)}>
                  <input
                    class="option__input"
                    type="radio"
                    name="selectedDeliveryService"
                    value={`${method.id}_uf`}
                    checked={$cart.delivery_service_id === method.id && !$cart.payment_on_delivery}
                  >
                  <div class="option__name">{method.name}</div>
                  <div class="option__price">{ parseFloat(method.price_upfront).toFixed(2) } zł</div>
                </label>
              {/each}
            </div>
          {/if}

          {#if anyOnDelivery(response) && !$cart.any_digital}
            <div class="options__label">Płatność przy odbiorze:</div>
            <div class="options__list">
              {#each response.filter(item => item.price_on_delivery != null) as method}
                <label onclick={() => select(method.id, true)}>
                  <input
                    class="option__input"
                    type="radio"
                    name="selectedDeliveryService"
                    value={`${method.id}_od`}
                    checked={$cart.delivery_service_id === method.id && $cart.payment_on_delivery}
                  >
                  <div class="option__name">{method.name}</div>
                  <div class="option__price">{ parseFloat(method.price_on_delivery).toFixed(2) } zł</div>
                </label>
              {/each}
            </div>
          {/if}
        {/if}
      {/await}
    </div>
  </Modal>
{/if}

{#if showLockerModal}
  <Modal onclose={() => showLockerModal = false} wide>
    <InpostGeowidget
      token={selectedMethod.geowidget_token}
      baseUrl={selectedMethod.geowidget_base_url}
      onselect={handleLockerSelect}
    />
  </Modal>
{/if}


<style>
  .delivery {
    border: 1px solid #e0e0e0;
    margin-bottom: 15px;
    padding: 20px 25px;
  }

  .delivery__info {
    display: flex;
    justify-content: space-between;
  }

  .delivery__value {
    font-weight: bold;
  }

  .delivery__change {
    font-size: 0.8em;
    text-align: right;
    display: inherit;
    margin-bottom: -3px;
  }

  .delivery__locker {
    margin-top: 8px;
  }

  .delivery__locker-name {
    font-weight: bold;
  }

  .delivery__locker-address {
    font-size: 0.85em;
    color: #555;
    margin-bottom: 2px;
  }

  .selector__title {
    margin: 0 30px 15px 0;
    font-size: 1.2em;
    line-height: 1.3;
  }

  .options__label {
    font-weight: bold;
  }

  .options__list label {
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    margin-left: -5px;
    margin-right: -5px;
    padding-left: 5px;
    padding-right: 5px;
  }

  .option__input {
    margin: auto;
    margin-right: 7px;
    flex-grow: 0;
  }

  .option__name {
    flex-grow: 1;
  }

  .option__price {
    text-align: right;
    flex-grow: 0;
  }

  .options__list label:hover {
    background-color: #ececec;
    color: #323d8a;
  }

  .options__list + .options__label {
    margin-top: 15px;
  }

  .fetch-error {
    color: #c0392b;
    font-size: 0.9em;
    margin: 0 0 8px;
  }

  .retry-button {
    background: none;
    border: 1px solid currentColor;
    border-radius: 3px;
    color: #5D6AC5;
    cursor: pointer;
    font-size: 0.85em;
    padding: 4px 10px;
  }

  @media (max-width: 767px) {
    .delivery {
      margin-bottom: 10px;
      padding: 10px;
    }
  }
</style>
